import { NSARouterMakerResult, NSAHomePage } from "namirasoft-account-react";
import { ContentTemplateLayout } from "../ContentTemplateLayout";
import { ContentTemplateProps } from "../ContentTemplateProps";

interface HomePageProps extends NSARouterMakerResult, ContentTemplateProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<ContentTemplateLayout
			{...props}
		>
			<NSAHomePage
				{...props}
			/>
		</ContentTemplateLayout>
	);
}